if(!customElements.get('image-with-details')) {
    class ImageWithDetails extends HTMLElement {
        constructor() {
            super();
            this.#init();
        }

        #init() {
            this.details = this.querySelectorAll('.image-with-details__detail');
            
            for (const detail of this.details) {
                const summary = detail.querySelector('summary');
                if (!summary) continue;

                summary.addEventListener('click', (e) => this.#handleClick(e, detail));
            }
        }

        #handleClick(event, detailElement) {
            if (window.innerWidth >= 750 || screen.width >= 750) return;

            const quickAddButton = detailElement.querySelector('.quick-add-button');
            

            if (quickAddButton) {
                if(!detailElement.hasAttribute('open')) {
                    quickAddButton.click();
                    console.log('clicked');
                }
            }
        }
    }
  
    customElements.define('image-with-details', ImageWithDetails);
}
